export * from './components';

export * as Icons from './icons';

export * as palette from './theme/colors';

export { typography } from './theme/typography';

export { SolvTheme } from './theme/theme';
export { style } from './utils/css';
export { default as SolvThemeProvider } from './components/SolvThemeProvider';
export { WhiteLabelThemeProvider } from './components/SolvThemeProvider';
export {
  whiteLabelPalettes,
  WhiteLabelPaletteName,
  WhiteLabelPalette,
} from './theme/whiteLabelColors';
export { default as GlobalStyles } from './components/GlobalStyles';
export { default as CssReset } from './components/CssReset';
export {
  JigsawProvider,
  default as JigsawContext,
  useJigsaw,
} from './context/JigsawContext';
